import React from 'react'
import Input from './Input'

export default function PasswordInput (props) {
  return <Input {...props} type='password' minLength={6} />
}


